import React, { useEffect, useReducer } from "react";

import { useParams } from "reducers/hooks";
import {
  createContext,
  useContextSelector as useContextSelectorBase,
} from "common/context";

import mainReducer from "./reducer";
import INITIAL_STATE from "./initialState";

// const OrderContext = React.createContext();
const OrderContext = createContext();

const initializer = (path) => (initialValue = INITIAL_STATE) => {
  const json = JSON.parse(localStorage.getItem(path));
  return json || initialValue;
};

export default function OrderProvider({ children }) {
  const businessUid = useParams(["id"]).id;
  const reducerPath = `order-${businessUid}`;
  const [state, dispatch] = useReducer(
    mainReducer,
    INITIAL_STATE,
    initializer(reducerPath)
  );

  useEffect(() => {
    if (businessUid) {
      const payload = initializer(reducerPath)();
      dispatch({ type: "RESET_ORDER", payload });
    }
  }, [businessUid]);

  useEffect(() => {
    localStorage.setItem(`order-${businessUid}`, JSON.stringify(state));
  }, [state]);

  return (
    <OrderContext.Provider value={[state, dispatch]}>
      {children}
    </OrderContext.Provider>
  );
}

export const useOrder = () => useContextSelectorBase(OrderContext, (v) => v);
export const useOrderSelector = (selector, comparator) =>
  useContextSelectorBase(OrderContext, (v) => selector(v[0]), comparator);
export const useOrderDispatch = () =>
  useContextSelectorBase(OrderContext, (v) => v[1]);
